import { Routes } from '@angular/router';
import { CompetitionGroupListComponent } from './pages/competition-groups-list/competition-group-list.component';
import { StandingsComponent } from './pages/competition-group-pages/standings/standings.component';
import { CompGroupWrapperComponent } from './pages/competition-group-pages/common/components/comp-group-wrapper/comp-group-wrapper.component';
import { ParticipantsListComponent } from './pages/competition-group-pages/participants-list/participants-list.component';
import { GroupFormsListComponent } from './pages/competition-group-pages/group-forms-list/group-forms-list.component';
import { TournamentConfigurationsComponent } from './pages/competition-group-pages/tournament-configurations/tournament-configurations.component';
import { FormSubmissionComponent } from '../tour-management/pages/tournament-management/form-submission/form-submission.component';
import { FormResultsComponent } from './pages/competition-group-pages/form-results/form-results.component';
import { FormBettingComponent } from './pages/competition-group-pages/form-betting/form-betting.component';
import { SimulateResultsFormFillerComponent } from './pages/competition-group-pages/simulate-results-form-filler/simulate-results-form-filler.component';

export const routes: Routes = [
  {
    path: '',
    component: CompetitionGroupListComponent,
  },
  {
    path: ':compGroupId',
    component: CompGroupWrapperComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'standings',
      },
      {
        path: 'standings',
        component: StandingsComponent,
      },
      {
        path: 'participants',
        component: ParticipantsListComponent,
      },
      {
        path: 'forms',
        component: GroupFormsListComponent,
      },
      {
        path: 'configurations',
        component: TournamentConfigurationsComponent,
      },
    ],
  },
  {
    path: ':compGroupId/formBetting/:formId',
    component: FormBettingComponent,
  },
  {
    path: ':compGroupId/formSubmission/:formId',
    component: FormSubmissionComponent,
  },
  {
    path: ':compGroupId/simulateResults/:formId',
    component: SimulateResultsFormFillerComponent,
  },
  {
    path: ':compGroupId/formResults/:formId',
    component: FormResultsComponent,
  },
];
